<template>
    <div>
        <div class="m-top" module="top">
            <div class="g-wrapper-new g-clearfix">
                <div class="top-welcome">
                    <span>您好！欢迎光临在线工业超市</span>
                </div>
                <div class="top-links">
                    <span class="item" v-if="userinfo">
                        <a class="link" href="/OrderList" :title="userinfo.Name">{{ userinfo.Name }}</a>
                    </span>
                    <span class="item" v-else>
                        <a class="link" href="javascript:void(0);" @click="login()" title="登录">登录</a>
                    </span>
                    <span class="item" v-if="userinfo">
                        <a class="link" href="javascript:void(0);" @click="isLogout">退出登录</a>
                    </span>
                    <span class="item">
                        <a class="link" href="/ShopCar" title="购物车">购物车</a>
                    </span>
                    <span class="item">
                        <a class="link" href="/InquiryOrder" title="询价单">询价单</a>
                    </span>
                    <span class="item">400-665-8016</span>
                </div>
            </div>
        </div>
        <div class="m-header">
            <div class="header-wrap" id="headerWrap">
                <div class="g-wrapper-new g-clearfix" module="header">
                    <a href="/" class="header-logo" alt="LOGO">
                        <img class="normal" src="../assets/picture/logo-xs.png" />
                    </a>
                    <div class="header-main">
                        <div class="header-search" id="productSearchWrap" module="hot-search">
                            <div class="search-input">
                                <input
                                    type="text"
                                    class="input"
                                    v-model="productSearchInput"
                                    placeholder="请输入您要搜索的产品名称、品牌或型号"
                                    autocomplete="off"
                                    @keypress="enterSearch($event)"
                                />
                                <a
                                    :href="
                                        '/search?' +
                                            (categoryID ? 'CategoryID=' + categoryID + '&' : '') +
                                            (brandID ? 'BrandID=' + brandID + '&' : '') +
                                            'keyword=' +
                                            productSearchInput
                                    "
                                    class="btn"
                                    id="productSearchBtn"
                                    alt="搜索"
                                >
                                    <i>搜索</i>
                                </a>
                            </div>
                            <div class="search-think hide" id="searchSuggest"></div>
                        </div>
                    </div>
                    <div class="inquiry">
                        <a href="/Inquiry" style="font-size: 16px;color: #f03a58;">未搜索到？点击询价</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="m-menu">
            <div class="menu-wrap g-clearfix">
                <a href="javascript:void 0;" class="menu-categories" id="headerNav" alt="全部商品分类">全部商品分类</a>

                <ul class="menu-list">
                    <li>
                        <a href="/Contact" target="_blank" title="商务合作">商务合作</a>
                    </li>
                    <li>
                        <a href="/SmartCabinet" target="_blank" title="智能柜">智能柜</a>
                    </li>
                    <!--                    <li>-->
                    <!--                        <a href="http://www.cesseon.com" target="_blank" title="走进西始">走进西始</a>-->
                    <!--                    </li>-->
                </ul>

                <div class="categories-container hide" id="headerNavWrap">
                    <div class="m-categories-list" module="menu-categories">
                        <!-- 需要显示子分类  加trigger类 -->
                        <!-- <div class="categories-item trigger"> -->
                        <!-- 胶黏剂 / 车间化学品 / 涂料/标记 -->
                        <!-- <div class="categories-item">
                                <div class="category-title" module="menu-category-1">
                                    <img
                                    class="category-icon category-icon-white"
                                    src="../assets/picture/b8e1162d-026a-4d21-a0cf-2554c73e1478.png"
                                    >
                                    <img
                                    class="category-icon category-icon-black"
                                    src="../assets/picture/64743a47-d901-4367-b2e8-e21de51e86a5.png"
                                    >
                                    <a href="search?CategoryID=16" class="title" target="_blank" title="胶黏剂">胶黏剂</a>
                                    <div class="title">&nbsp;/&nbsp;</div>
                                    <a href="#" class="title" target="_blank" title="车间化学品">车间化学品</a>
                                    <div class="title">&nbsp;/&nbsp;</div>
                                    <a href="#" class="title" target="_blank" title="涂料/标记">涂料/标记</a>
                                </div>
                                <div class="category-body">
                                    
                                    <div class="m-category-children">
                                    <div class="subcategory-list">
                                        <div class="subcategory-container">
                                        <div class="subcategory-inner">
                                            <div class="subcategory-inner-row">
                                            <div class="subcategory-inner-title">
                                                <a href="search?CategoryID=16">粘胶剂</a>
                                                <img src="../assets/images/icon_next.png" alt="">
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>-->
                        <!-- 劳保安防 -->
                        <div class="categories-item trigger" v-for="(item, key) in categoryList" :key="key">
                            <div class="category-title" module="menu-category-1">
                                <img
                                    class="category-icon category-icon-white"
                                    src="../assets/picture/b8e1162d-026a-4d21-a0cf-2554c73e1478.png"
                                />
                                <img
                                    class="category-icon category-icon-black"
                                    src="../assets/picture/64743a47-d901-4367-b2e8-e21de51e86a5.png"
                                />
                                <a :href="'search?CategoryID=' + item.CategoryID" class="title" target="_self" :title="item.Name">{{
                                    item.Name
                                }}</a>
                            </div>
                            <!-- style="width: 140px;" 2020-3-25添加 二级分类滚动 -->
                            <div class="category-body" style="width: 140px;">
                                <div class="m-category-children">
                                    <div class="subcategory-list">
                                        <div class="subcategory-container">
                                            <div class="subcategory-inner">
                                                <div class="subcategory-inner-row">
                                                    <!-- <div class="subcategory-inner-title">
                                                        <a href="search?CategoryID=41">润滑剂</a>
                                                        <img src="../assets/images/icon_next.png" alt />
                                                    </div> -->
                                                    <div
                                                        class="subcategory-inner-content"
                                                        v-for="(subItem, subKey) in item.SubsetList"
                                                        :key="subKey"
                                                    >
                                                        <a
                                                            :href="'search?CategoryID=' + subItem.CategoryID"
                                                            class="subcategory-inner-link"
                                                            >{{ subItem.Name }}</a
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { GlobalFun } from '@/common/utils';
import { Logout, GetCategoryList } from '../common/api';
export default {
    name: 'global-head',
    data() {
        return {
            productSearchInput: '',
            userinfo: null,
            brandID: '',
            categoryID: '',
            categoryList: []
        };
    },
    props: {
        isIndex: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    async created() {
        this.userinfo = await GlobalFun.getCookie('UserInfo');
        this.brandID = this.getUrlKey('BrandID');
        this.categoryID = this.getUrlKey('CategoryID');
    },
    async mounted() {
        if (this.isIndex) {
            $('#headerNavWrap').removeClass('hide');
        } else {
            $('#headerNav').hover(
                function() {
                    $('#headerNavWrap').removeClass('hide');
                },
                function() {
                    $('#headerNavWrap').hover(
                        function() {
                            $(this).removeClass('hide');
                        },
                        function() {
                            $(this).addClass('hide');
                        }
                    );
                    $('#headerNavWrap').addClass('hide');
                }
            );
        }
        this.categoryList = await GetCategoryList();
    },
    methods: {
        enterSearch(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        },
        search() {
            if (this.productSearchInput.trim() != '') {
                this.brandID = this.getUrlKey('BrandID');
                this.categoryID = this.getUrlKey('CategoryID');
                window.location.href =
                    '/search?' +
                    (this.categoryID ? 'CategoryID=' + this.categoryID + '&' : '') +
                    (this.brandID ? 'BrandID=' + this.brandID + '&' : '') +
                    'keyword=' +
                    this.productSearchInput;
                // this.$router.push({
                //   path: "/search",
                //   query: { keyword: this.productSearchInput }
                // });
                //this.$emit("HomeSearch", this.productSearchInput);
            }
        },
        getUrlKey: function(name) {
            return (
                decodeURIComponent(
                    (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')
                ) || null
            );
        },
        isLogout() {
            this.$confirm('是否注销?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(async () => {
                    Logout().then(() => {
                        GlobalFun.delCookie('UserInfo');
                        let url = window.location.pathname + window.location.search;
                        this.$router.push({
                            path: '/login',
                            query: { url: url }
                        });
                    });
                })
                .catch(() => {});
        },
        login() {
            let url = window.location.pathname + window.location.search;
            this.$router.push({
                path: '/login',
                query: { url: url }
            });
        }
    }
};
</script>

<style>
.inquiry {
    margin-left: 30px;
    height: 40px;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.subcategory-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: auto;
}
.subcategory-inner {
    flex: 1;
    height: auto;
    padding: 10px 20px;
    flex-wrap: wrap;
}
.subcategory-inner-row {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}
.subcategory-inner-title {
    width: 100%;
    color: #666;
    display: flex;
    align-items: center;
    height: 20px;
}
.subcategory-inner-title img {
    width: 15px;
    height: 15px;
}
.subcategory-inner-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 30px;
}
.subcategory-inner-link {
    padding: 5px;
    color: #7f7f7f;
}
</style>
